import { ChargingSessionModel } from './charging-session-models'

/** Sessions store that holds the visible session data to be exported. */
let sessionsForExport: ChargingSessionModel[] = []

export function getSessionsForExport(): ChargingSessionModel[] {
  return sessionsForExport
}

export function setSessionsForExport(sessions: ChargingSessionModel[]): void {
  sessionsForExport = sessions
}
